import React from "react";
import { FC } from "react";

export interface CommonLayoutProps {
  index: string;
  nextHref?: string;
  backtHref?: string;
  nextBtnText?: string;
}

const CommonLayout: FC<CommonLayoutProps> = ({
  index = "01",
  children,
  nextHref,
  nextBtnText,
  backtHref,
}) => {
  return (
    <div
      className={`nc-PageAddListing1 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddListing1"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">{index}</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / 6
          </span>
        </div>

        {/* --------------------- */}
        <div className="listingSection__wrap ">{children}</div>

        {/* --------------------- */}
        {/* <div className="flex justify-end space-x-5">
          <ButtonSecondary href={backtHref}>Kembali</ButtonSecondary>
          <ButtonPrimary href={nextHref}>
            {nextBtnText || "Selanjutnya"}
          </ButtonPrimary>
        </div> */}
      </div>
    </div>
  );
};

export default CommonLayout;
